import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection } from '@iotv/iotv-v3-types';

const typeName = 'SoilMoistureDev';

export type SoilMoistureDevProps = {
  qRCode?: string;
  devEUI?: string;

  version?: number;
};

export class SoilMoistureDev extends ModelCommon {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
  }

  qRCode?: string;
  devEUI?: string;

  version?: number;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      qRCode: { type: 'String', editable: true, label: 'QR Code', name: 'qRCode', description: 'QR Code for scanning the device' },
      devEUI: { type: 'String', editable: true, label: 'Dev EUI', name: 'devEUI', description: 'Device EUI of the device' },
      name: { type: 'String', editable: true, label: 'Name', name: 'name', description: 'User set name of the device' },
      version: { type: 'Number', editable: true, label: 'Version', name: 'version', description: 'Firmware version installed into the device' },
    };
  };
}
